import type { TranslationKey } from "../locales";
import { LocalizedError, type LocalizedErrorOptions } from "./localized-error";

/**
 * A row the caller named is not theirs to act on: unknown, already deleted, or another
 * organisation's, which the policies make indistinguishable on purpose — which ids exist
 * elsewhere is not the caller's to learn. 404, code `not_found`.
 *
 * It is also the answer for an update or delete whose `.returning()` came back empty, because on
 * the claims connection an absent row and a foreign row are the same thing.
 */
export class NotFoundError extends LocalizedError {
	readonly status = 404 as const;
	readonly code: string;

	constructor(key: TranslationKey, options?: LocalizedErrorOptions) {
		super(key, options);
		this.name = "NotFoundError";
		this.code = options?.code ?? "not_found";
	}
}
